export default "__VITE_ASSET__Kg5aoecN__"